/**
 * Escapa texto para interpolarlo con seguridad en HTML crudo
 * (SweetAlert `html:`, `innerHTML`, etc.), donde React NO escapa por ti.
 * Neutraliza inyección de etiquetas/atributos con datos de usuario o del servidor.
 */
export const escapeHtml = (value) =>
  String(value ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[c]));
